import { writable } from "svelte/store";

export type Kind = "info" | "error" | "success";

type Toast = {
  id: number;
  message: string;
  duration: number;
  kind: Kind;
};

const setupStore = () => {
  return writable<Toast[]>([]);
};

export const store = setupStore();
const timeoutIds: { [id: number]: number } = {};

let idCounter = 1;

const show = (message: string, kind?: Kind, duration?: number) => {
  // If rendered in a webview then pop the native toasts instead
  if (globalThis.ReactNativeWebView) {
    globalThis.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: "toast",
        data: {
          text: message,
          type: kind === "info" ? "normal" : kind === "error" ? "danger" : kind,
        },
      }),
    );
  } else {
    store.update((toasts) => {
      const id = ++idCounter;
      const d = duration ?? 5000;
      toasts.push({
        id: id,
        message: message,
        kind: kind ?? "info",
        duration: d,
      });

      const timeoutId = window.setTimeout(() => {
        store.update((toasts) => {
          const timeoutId = timeoutIds[id];
          if (timeoutId) {
            clearTimeout(timeoutId);
          }

          return toasts.filter((t) => t.id !== id);
        });
      }, d);

      timeoutIds[id] = timeoutId;

      return toasts;
    });
  }
};

export const info = (message: string, duration?: number) => {
  show(message, "info", duration);
};

export const error = (message: string, duration?: number) => {
  show(message, "error", duration);
};

export const success = (message: string, duration?: number) => {
  show(message, "success", duration);
};
